import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
//
//
//
//
//
//
//
//
//
//
//
//

import Select2 from "@Shared/components/inputs/select2";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "CustomDropdownField",
  components: {
    Select2
  },
  props: {
    data: {
      type: Array,
      default: () => []
    },
    value: {
      type: [String, Number],
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    select2Options() {
      return {
        closeOnSelect: true,
        placeholder: this.$t("global.actions.chooseOption"),
        dropdownParent: "#custom-fields-card"
      };
    }
  },
  methods: {
    initSelect2() {
      this.$nextTick(() => {
        this.$refs.select.initSelect2(this.select2Options);
      });
    },
    formatData(data) {
      return data && _mapInstanceProperty(data).call(data, ({
        name,
        id
      }) => {
        return {
          text: name,
          id
        };
      });
    },
    handleSelectChange({
      id
    }) {
      this.$emit("change", id);
    }
  }
});